
const NOMINATIM_QUERY = "https://nominatim.openstreetmap.org/search.php?&format=jsonv2&q="

export type NominatimBoundingBox = [string, string, string, string]

export interface NominatimSearchRecord {
    place_id: number
    licence: string
    osm_type: string
    osm_id: number
    boundingbox: NominatimBoundingBox
    lat: string
    lon: string
    display_name: string
    place_rank: number
    category: string
    type: string
    importance: number
}

export type NominatimSearchResponse = Array<NominatimSearchRecord>

export async function fetchGeocode(geocode: string): Promise<NominatimSearchResponse> {
    const url = encodeURI(NOMINATIM_QUERY + geocode)
    const req = await fetch(url)
    return await req.json()
}

export function getGeocodeUrl(geocode: string): string {
    return encodeURI(NOMINATIM_QUERY + geocode)
}

